/** Created by azhou on 2019/3/13.*/
<template>
  <div>
    <div v-if="StoreRoomArr.meetArr.length<=0">
      还没有添加房型，无法获取客房日历
      <span class="text-link" @click="goAddRoom">去添加房型</span>
    </div>
    <div v-else>
      <div class="text-left mb-3">按房型查看：
        <el-select v-model="roomType" placeholder="请选择" size="small">
          <el-option v-for="item in StoreRoomArr.meetArr" :key="item.id" :label="item.title" :value="item.id" />
        </el-select>
        <el-button class="ml-5" @click="showBatch = true" type="primary" size="small">批量修改</el-button>
      </div>
      <div class="bg-white d-center-between p-2">
        <i class="iconfont icon-jiantou-copy cursor-pointer" @click="updateDayList(-1)"
           :class="{'disabled-arrow':!leftArrow}"></i>
        <h4>{{yearMonth}}</h4>
        <i class="iconfont icon-jiantou cursor-pointer" @click="updateDayList(1)"></i>
      </div>
      <div class="bg-dark text-warning d-center-around">
        <div v-for="item in weekDays" class="w-25 p-1" :class="{'weekend':item === '五' || item === '六'}" :key="item">{{item}}</div>
      </div>
      <div class="bg-white d-center-start pl-2 pr-2" v-for="(item,index) in days" :key="index">
        <div class="day-price" :class="{'disabled':!child || child.disabled, 'bg-orange': child.id}"
             v-for="(child,index) in item" :key="index" @click="changeDatePrice(child)">
          <p class="mb-1">{{child.day ? child.day + '号' : ''}}</p>
          <p>余房：{{child.total_1 ? child.total_1 : 0}}间</p>
          <div v-if="brand">
            <p>市价：&yen;{{child.price1 ? child.price1 : '0.00'}}</p>
            <p>旅价：&yen;{{child.price2 ? child.price2 : '0.00'}}</p>
            <p>房价：&yen;{{child.price3 ? child.price3 : '0.00'}}</p>
          </div>
          <div v-else>
            <p>团价：&yen;{{child.price1 ? child.price1 : '-'}}</p>
            <p v-if="userInfo.type == '5'">散客：{{child.price3 ? child.price3 : '-'}}元</p>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :title="`修改${currentDate.date}日房型动态`" :visible.sync="changeDatePriceFlag" center>
      <el-form :model="currentDate" :rules="rules" ref="currentDate" label-width="80px" class="demo-ruleForm w-60 ml-auto mr-auto">
        <el-form-item label="房型">
          <span class="ml-2" v-if="roomType">{{StoreRoomArr.meetArr.filter(item => item.id == roomType)[0].title}}</span>
        </el-form-item>
        <el-form-item label="余房" prop="total">
          <el-input  placeholder="请输入余房间数" size="small" v-model.number="currentDate.total" maxlength="4"><template slot="append">间</template></el-input>
        </el-form-item>
        <el-form-item :label="brand ? '门市价' : '团队价'" prop="price1">
          <el-input  placeholder="请输入团队价" size="small" v-model.number="currentDate.price1" maxlength="7"><template slot="append">元</template></el-input>
        </el-form-item>
        <el-form-item label="采购商价" prop="price2" v-if="brand">
          <el-input  placeholder="请输入采购商价" size="small" v-model.number="currentDate.price2" maxlength="7"><template slot="append">元</template></el-input>
        </el-form-item>
        <el-form-item label="订单雨价" prop="price3" v-if="brand">
          <el-input  placeholder="请输入订单雨价" size="small" v-model.number="currentDate.price3" maxlength="7"><template slot="append">元</template></el-input>
        </el-form-item>
        <el-form-item label="散客价" prop="price3" v-if="userInfo.type == '5'">
          <el-input  placeholder="请输入散客价" size="small" v-model.number="currentDate.price3" maxlength="7"><template slot="append">元</template></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button class="mr-5" @click="changeDatePriceFlag = false">取 消</el-button>
        <el-button type="primary" @click="ensureChange('currentDate',1)">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="房型动态-批量修改" :visible.sync="showBatch" center>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" class="demo-ruleForm w-60 ml-auto mr-auto">
        <el-form-item label="日期" prop="batchdate">
          <el-date-picker class="w-100"  type="dates" size="small" v-model="ruleForm.batchdate" :picker-options="pickerOptions" value-format="MM-dd" placeholder="选择日期" />
        </el-form-item>
        <el-form-item label="房型" prop="inroomType">
          <el-select class="w-100" v-model="ruleForm.inroomType" placeholder="请选择" size="small">
            <el-option v-for="item in StoreRoomArr.meetArr" :key="item.id" :label="item.title" :value="item.id" >{{item.title}}（{{item.type | formatVar('roomStyle')}}）</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="余房" prop="total">
          <el-input  placeholder="请输入余房间数" size="small" v-model.number="ruleForm.total" maxlength="4"><template slot="append">间</template></el-input>
        </el-form-item>
        <el-form-item :label="brand ? '门市价' : '团队价'" prop="price1">
          <el-input  placeholder="请输入团队价" size="small" v-model.number="ruleForm.price1" maxlength="7"><template slot="append">元</template></el-input>
        </el-form-item>
        <el-form-item label="采购商价" prop="price2" v-if="brand">
          <el-input  placeholder="请输入采购商价" size="small" v-model.number="ruleForm.price2" maxlength="7"><template slot="append">元</template></el-input>
        </el-form-item>
        <el-form-item label="订单雨价" prop="price3" v-if="brand">
          <el-input  placeholder="请输入订单雨价" size="small" v-model.number="ruleForm.price3" maxlength="7"><template slot="append">元</template></el-input>
        </el-form-item>
        <el-form-item label="散客价" prop="price3" v-if="userInfo.type == '5'">
          <el-input  placeholder="请输入散客价" size="small" v-model.number="ruleForm.price3" maxlength="7"><template slot="append">元</template></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="showBatch = false">取消</el-button>
          <el-button class="ml-5" type="primary" @click="ensureChange('ruleForm',2)">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import {mapState,mapGetter,mapActions, mapGetters} from 'vuex'

  export default {
    name: 'Calendar',
    data() {
      return {
        roomType: '',
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        days:[],
        weekDays:['日','一','二','三','四','五','六'],
        pickedDay: '',
        currentDate: {},   //点击设置特殊价格的当前项
        leftArrow: false,
        changeDatePriceFlag: false,
        showBatch: false,
        batchdate: [],
        inroomType: '',
        spareroom: 0,
        teamprice: 0,
        pickerOptions: {
          disabledDate(date) {
            return date.getTime() < Date.now() - 1*24*60*60*1000
          }
        },
        ruleForm: {
          batchdate: [],
          inroomType: '',
          total: '',
          price1: '',
          price3: 100
        },
        rules: {
          batchdate: [
            { required: true, message: '请选择日期', trigger: 'change' },
          ],
          inroomType: [
            { required: true, message: '请选择房型', trigger: 'change' }
          ],
          total: [
            { type: 'number', required: true, message: '请输入余房数量', trigger: 'blur' },
            {
              validator(rule, value, callback) {
                if (Number.isInteger(Number(value)) && Number(value) >= 0 && Number(value) < 10000) {
                  callback()
                } else {
                  callback(new Error('请输入整数'))
                }
              },trigger: 'blur'
            }
          ],
          price1: [
            { type: 'number', required: true, message: '请输入团队价', trigger: 'blur' },
            {
              validator(rule, value, callback) {
                let reg = /(^[1-9]{1}[0-9]*$)|(^[0-9]*\.[0-9]{2}$)/
                if (reg.test(value)) {
                  callback()
                } else {
                  callback(new Error('请输入正整数或者保留两位小数'))
                }
              },trigger: 'blur'
            }
          ],
          price2: [
            { type: 'number', required: true, message: '请输入采购商价', trigger: 'blur' },
            {
              validator(rule, value, callback) {
                let reg = /(^[1-9]{1}[0-9]*$)|(^[0-9]*\.[0-9]{2}$)/
                if (reg.test(value)) {
                  callback()
                } else {
                  callback(new Error('请输入正整数或者保留两位小数'))
                }
              },trigger: 'blur'
            }
          ],
          price3: [
            { type: 'number', required: true, message: '请输入散客价', trigger: 'blur' },
            {
              validator(rule, value, callback) {
                let reg3 = /(^[1-9]{1}[0-9]*$)|(^[0-9]*\.[0-9]{2}$)/
                if (reg3.test(value)) {
                  callback()
                } else {
                  callback(new Error('请输入正整数或者保留两位小数'))
                }
              },trigger: 'blur'
            }
          ]
        }
      }
    },
    computed: {
      ...mapState(['StoreRoomArr','StoreCalendar']),
      ...mapGetters(['userInfo']),
      yearMonth() {
        return `${this.year}-${this.month < 10 ? '0' + this.month : this.month}`;
      },
      brand() { return this.userInfo.type == 8 }
    },
    created() {
      //获取房间列表
      this.getRoomLists();
    },
    watch: {
      StoreRoomArr(newVal) {
        if (newVal[0]) { this.roomType = newVal[0].id; this.roomTitle = newVal[0].title }
      },
      /*改变房型时同步客房日历*/
      roomType(newVal) { this.getCalendar();},
      //改变日期时间时同步客房日历
      yearMonth() { this.getCalendar(); },
      //对获取的日历进行处理
      StoreCalendar() {
        this.days = this.StoreCalendar.map(v => {
          v.forEach(t => {
            if (t) {
              let today = new Date().getTime();
              let tDay = Date.parse(new Date(`${this.yearMonth}-${t.day} 0:0:0`));
              t.disabled = tDay < today
            }
          })
          return v
        })
      }
    },
    methods: {
      ...mapActions(['getStoreCalendar','getRoomLists','setStoreCalendar']),
      /*获取客房日历*/
      getCalendar() {
        //默认获取第一个房型的价格日历
        this.getStoreCalendar({
          room_id:this.roomType,
          year_day:this.yearMonth
        });
      },
      /*点击后更新日期列表*/
      updateDayList(index) {
        //当不显示左箭头还减少当前月时，不作处理，直接返回
        if (!this.leftArrow && index < 0) return;
        this.month += index;
        if (this.month <= 0) {
          this.month = 12;
          this.year--;
        }
        if (this.month > 12) {
          this.month = 1;
          this.year++;
        }
        let today = new Date();
        if (this.year > today.getFullYear()) this.leftArrow = true;
        if (this.year === today.getFullYear()) this.leftArrow = this.month > today.getMonth() + 1;
        this.getCalendar();
      },
      /*提交修改数据*/
      changeDatePrice(item) {
        if (!item || item.disabled) return;
        this.changeDatePriceFlag = true;
        this.currentDate = {
          price1: Number(item.price1),
          price2: Number(item.price2),
          total: Number(item.total_1),
          price3: Number(item.price3),
          //roomcal_id: item.id,
          date:`${this.month < 10 ? '0' + this.month : this.month}-${item.day < 10 ? '0' + item.day : item.day}`
        }
      },
      /*提交修改价格表单*/
      ensureChange(formName,index) {
        if (!this.$GFUN.powerIsInArray([194,444,562])) { this._alert('您没有相关权限！',null,'error'); return; }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let data = {}
            if (index == 2) {
              data = {
                date: this.ruleForm.batchdate.join(','),
                total: this.ruleForm.total,
                price1: this.ruleForm.price1,
                price2: this.ruleForm.price2,
                price3: this.ruleForm.price3,
                room_id:this.ruleForm.inroomType,
              }
            } else {
              data = {
                room_id: this.roomType,
                ...this.currentDate
              }
            }
            if (!this.brand) delete data.price2
            if (this.userInfo.type == 3) {data.price3 = ''}
            this.setStoreCalendar({
              data,
              successFun: () => {
                switch (index) {
                  case 2:
                    this.showBatch = false;
                    this.$refs[formName].resetFields();
                    break;
                  default:
                    this.changeDatePriceFlag = false;
                    break;
                }
                this.$message.success('修改成功');
                this.getCalendar();
              }
            })
          } else {
            return false;
          }
        });
      },
      /*添加房型*/
      goAddRoom() {
        let query = {step:'3',storeId:this.$route.query.storeId,GST:this.$route.query.GST}
        this.$router.replace({name:'RoomMeetManage',query})
      }
    }
  }
</script>
<style lang="scss" scoped>
  .disabled-arrow{
    color: #fff;
    cursor: default;
  }
  .weekend{
    background: #fdb900;
    color: #000;
  }
  .bg-white{
    .day-price:last-child{
      margin-right: 0%
    }
  }
  .day-price{
    width: 13%;
    min-height: 80px;
    margin: 10px 0;
    margin-right: 1.5%;
    padding: 10px;
    text-align: left;
    cursor: pointer;
    border-radius: 5px;
    border: 1px solid #eee;
    box-sizing: border-box;
    font-size: 13px;
    &:hover{
      background: #eee;
    }
    &.disabled{
      background: #eee;
      cursor: default;
      color: #919191;
      border-radius: 0
    }
    p{
      height:17px
    }
  }
  .bg-orange{
    background-color: #e7d9be;
    color: #fff
  }
</style>
